import React from 'react';
import services from '../../services';
import { Select } from 'antd';
import Lang from '../../lang'
const {Option} = Select;

class EntityFilter extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            popUpForm : '',
            data : [],
            entityDataList : [],
            parcelHolder : {},
            holderDetail : {},
            searchValid : 0,
            optionsEntityList : '',
            entity_list_object : {},
            defaultSelection:"",
            error:null,
         }
    }

    componentDidUpdate(prevProps){
        if(this.props.resetEntityList !== prevProps.resetEntityList && this.props.returnKey === "nifap"){
            // console.log("ppppppp",prevProps.resetEntityList,this.props.resetEntityList)
            this.setState({
                optionsEntityList : '',
                defaultSelection : ''
            })
        }
    }

    onSearch = async(e) => {
        try {
            if(e.length >= 3){
         
            let res = await services.EntityList.getEntityList(this.props.modulename,e);
            if(res){
                this.setState({
                    entityDataList: res.entityList,
                    entity_list_object: res.entity_row,
                    searchValid : e.length,
            
                    },()=>this.entityListOption())
                }
            }else{
                this.setState({
                    searchValid : 0
                })
            }
            this.setState({defaultSelection: e})
        } catch (error) {
            this.setState({error})
        }
    }
    
     entityListOption = () => {
        let optionsEntityList = ''
        if(this.props.returnKey === "codEntidade"){
            optionsEntityList = (
                this.state.entityDataList.map((_r,i)=>(
                    <Option key={i} value={_r.codEntidade}>{_r.nome}</Option>
                ))
            )
        }else if(this.props.returnKey === "nifap"){
            optionsEntityList = (
                this.state.entityDataList.map((_r,i)=>(
                    <Option key={i} value={_r.nifap}>{_r.nome}<br />{_r.nifap}</Option>
                ))
            )
        }else{
            optionsEntityList = (
                this.state.entityDataList.map((_r,i)=>(
                    <Option key={i} value={_r.nif}>{_r.nome}<br />{_r.nifap}</Option>
                ))
            )
        }
    
        this.setState({
            optionsEntityList
        })
       }
    handleSelect = (value) => {
        try {
            this.props.getselectedEntity(value);
            this.setState({defaultSelection: value})
        } catch (error) {
            this.setState({error})
        }
     }
    
    render(){
        if(this.state.error){
            throw this.state.error
        }
        return (
            <div className="form-group position-relative k-mt-0"> 
                <div className={"input-box active-grey " + (this.props.newClass || '') } style={{marginTop:'10px'}} >
                <Select 
                    onChange={this.handleSelect} 
                    showSearch
                    onSearch={this.onSearch}
                    style={{width:"100%"}} 
                    value={this.state.defaultSelection || (this.props.newPlaceHolder || '')}
                    placeholder="Pesquisar por Nº ou Nome" 
                    optionFilterProp='children' 
                    notFoundContent="Entidade não encontrada, refina os critérios de pesquisa"
                    >
                    {
                    this.state.searchValid >= 3 &&
                        this.state.optionsEntityList
                    }
                    </Select>
                </div>
                <a className={"search-icon" + ((!!this.props.newClass && this.props.newClass !== 'transferir-ant-select')  ? ' mt-2' : '')}>
                <i className="fas fa-search"></i>
                </a>
             </div>
        )
    }
}

export default EntityFilter;